import React from "react";

import { toast } from "react-toastify";

export default function exportHTML({
  canvasDimension,
  finalDOMObj,
  animationFinalObjToString,
  layerLink,
  completeObj,
  typeDiff,
  expandClose,
  animationObjecStringified,
}) {
  return `<html><head>
    <meta charset="utf-8">
    ${layerLink}
    <meta http-equiv="Content-Type" content="text/html; charset=UTF-8" />
    <meta name="format-detection" content="telephone=no" />
    <meta http-equiv="X-UA-Compatible" content="IE=Edge" />
    <meta name="ad.size" content="width=${canvasDimension?.width},height=${
    canvasDimension?.height
  }"/>
   <meta name="viewport" content="width=device-width, initial-scale=1.0, maximum-scale=1.0, minimum-scale=1.0">
    <link rel="stylesheet" href="https://cdnjs.cloudflare.com/ajax/libs/font-awesome/4.4.0/css/font-awesome.min.css">
    <script>
        var loaded = false;
    </script>
    <script src="https://s0.2mdn.net/ads/studio/Enabler.js" onload="loaded=true;"></script>
    <script type="text/javascript" src="https://code.jquery.com/jquery-latest.js" ></script>
    <script  type="text/javascript" src="https://cdnjs.cloudflare.com/ajax/libs/gsap/1.20.3/TweenMax.min.js"></script>
    <!--<script type="text/javascript" src="https://baijs.com/tinyscrollbar/js/jquery.tinyscrollbar.js" ></script> -->
    <script>!function(t){"function"==typeof define&&define.amd?define(["jquery"],t):"object"==typeof exports?module.exports=t(require("jquery")):t(jQuery)}(function(t){"use strict";var o="tinyscrollbar",e={axis:"y",wheel:!0,wheelSpeed:40,wheelLock:!0,touchLock:!0,trackSize:!1,thumbSize:!1,thumbSizeMin:20};function i(i,n){this.options=t.extend({},e,n),this._defaults=e,this._name=o;var s=this,h=i.find(".viewport"),c=i.find(".overview"),a=i.find(".scrollbar"),u=a.find(".track"),r=a.find(".thumb"),d="ontouchstart"in document.documentElement,m="onwheel"in document.createElement("div")?"wheel":void 0!==document.onmousewheel?"mousewheel":"DOMMouseScroll",l="x"===this.options.axis,p=l?"width":"height",S=l?"left":"top",f=0;function z(){return s.contentPosition>0}function w(){return s.contentPosition<=s.contentSize-s.viewportSize-5}function b(e,i){s.hasContentToSroll&&(t("body").addClass("noSelect"),f=i?r.offset()[S]:l?e.pageX:e.pageY,d&&(document.ontouchmove=function(t){(s.options.touchLock||z()&&w())&&t.preventDefault(),t.touches[0][o+"Touch"]=1,P(t.touches[0])},document.ontouchend=k),t(document).bind("mousemove",P),t(document).bind("mouseup",k),r.bind("mouseup",k),u.bind("mouseup",k),P(e))}function v(o){if(s.hasContentToSroll){var e=o||window.event,n=-(e.deltaY||e.detail||-1/3*e.wheelDelta)/40,h=1===e.deltaMode?s.options.wheelSpeed:1;s.contentPosition-=n*h*s.options.wheelSpeed,s.contentPosition=Math.min(s.contentSize-s.viewportSize,Math.max(0,s.contentPosition)),s.thumbPosition=s.contentPosition/s.trackRatio,i.trigger("move"),r.css(S,s.thumbPosition),c.css(S,-s.contentPosition),(s.options.wheelLock||z()&&w())&&(e=t.event.fix(e)).preventDefault()}o.stopPropagation()}function P(t){if(s.hasContentToSroll){var e=l?t.pageX:t.pageY,n=t[o+"Touch"]?f-e:e-f,h=Math.min(s.trackSize-s.thumbSize,Math.max(0,s.thumbPosition+n));s.contentPosition=h*s.trackRatio,i.trigger("move"),r.css(S,h),c.css(S,-s.contentPosition)}}function k(){s.thumbPosition=parseInt(r.css(S),10)||0,t("body").removeClass("noSelect"),t(document).unbind("mousemove",P),t(document).unbind("mouseup",k),r.unbind("mouseup",k),u.unbind("mouseup",k),document.ontouchmove=document.ontouchend=null}return this.contentPosition=0,this.viewportSize=0,this.contentSize=0,this.contentRatio=0,this.trackSize=0,this.trackRatio=0,this.thumbSize=0,this.thumbPosition=0,this.hasContentToSroll=!1,this.update=function(t,o){this.options.trackSize=o||this.options.trackSize;var e=p.charAt(0).toUpperCase()+p.slice(1).toLowerCase();switch(this.viewportSize=h[0]["offset"+e],this.contentSize=c[0]["scroll"+e],this.contentRatio=this.viewportSize/this.contentSize,this.trackSize=this.options.trackSize||this.viewportSize,this.thumbSize=Math.min(this.trackSize,Math.max(this.options.thumbSizeMin,this.options.thumbSize||this.trackSize*this.contentRatio)),this.trackRatio=(this.contentSize-this.viewportSize)/(this.trackSize-this.thumbSize),this.hasContentToSroll=this.contentRatio<1,a.toggleClass("disable",!this.hasContentToSroll),t){case"bottom":this.contentPosition=Math.max(this.contentSize-this.viewportSize,0);break;case"relative":this.contentPosition=Math.min(Math.max(this.contentSize-this.viewportSize,0),Math.max(0,this.contentPosition));break;default:this.contentPosition=parseInt(t,10)||0}return this.thumbPosition=this.contentPosition/this.trackRatio,r.css(S,s.thumbPosition),c.css(S,-s.contentPosition),a.css(p,s.trackSize),u.css(p,s.trackSize),r.css(p,s.thumbSize),s},s.update(),d&&(h[0].ontouchstart=function(t){1===t.touches.length&&(t.stopPropagation(),b(t.touches[0]))}),r.bind("mousedown",function(t){t.stopPropagation(),b(t)}),u.bind("mousedown",function(t){b(t,!0)}),t(window).resize(function(){s.update("relative")}),s.options.wheel&&window.addEventListener?i[0].addEventListener(m,v,!1):s.options.wheel&&(i[0].onmousewheel=v),s}t.fn[o]=function(e){return this.each(function(){t.data(this,"plugin_"+o)||t.data(this,"plugin_"+o,new i(t(this),e))})}});
    </script>
 
  <style>
  * { 
  -moz-box-sizing: border-box; 
  -webkit-box-sizing: border-box; 
   box-sizing: border-box; 
   } 
   body{
     padding:0;
     margin:0;
   }
  ${finalDOMObj.CssCollect} 
  .customScrollBar {
    padding-bottom:50px;
  }
  .customScrollBar::-webkit-scrollbar {
    background-color: $imc-white-color;
  }
  p{
    margin: 0 0 0px !important;
  }
  #Text0overview p{
    margin: 0 1px 0px !important;
  }
  .customScrollBar::-webkit-scrollbar {
    width: 6px;
    height: 6px;
  }
  
  .customScrollBar::-webkit-scrollbar-thumb {
    border-radius: 5px;
    box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.1);
    -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.1);
    background: rgba(0, 0, 0, 0.2);
  }
  
  .custonScrollBar::-webkit-scrollbar {
    background-color: $imc-white-color;
  }

  .disable .thumb {
    display:none;
    }
  
  </style>
  </head>
  
  <body class="customScrollBar">${typeDiff}

  <script>
  var arrObject=${animationFinalObjToString}
  var fps =${canvasDimension.fps}
  var tempGpsa = [];
  var count = 0;
  var clearTimer = [];
  var MaxDuration = [];
  var collectID = [];
  var loopAnimation =${canvasDimension.loopAnimation || 0}
  var set = true;
  let maxIndex = -1;
  let completeObj = ${completeObj};
  let animationObjecStringified = ${animationObjecStringified};
 
  function enableTxt(item) {
    var urltestGlobal= $('#canvas-page').data("global");
    var urltextGlobalCheck=$('#canvas-page').data("link") ||$("#canvas-page").data("global");
    
    if(urltextGlobalCheck && urltextGlobalCheck !=="undefined"){
      window.open(urltestGlobal)
    }else{
      var urltest = $(item).data("url");
      if(urltest!==undefined && urltest !=="http://" ){
      window.open(urltest);
      }else{
        return;
      }
    }
  }

  function getElements(elem) {
    let element = [];
    for (let i = 0; i < elem.length; i++) {
      element.push(document.getElementById(elem[i]));
   
    }
    return element;
  }

  function animationRepeat(AryObj) {
    var masterTimeLine = new TimelineMax({ repeat:${
      canvasDimension.checkLoops === true ? canvasDimension.loopAnimation : 0
    }});
        gsap.ticker.fps(fps);
       
        if (loopAnimation && set===true){
          Array.prototype.max = function() {
            return Math.max.apply(null, this);
          };
          for (let j = 0; j < AryObj.length; j++) {
            let obj = AryObj[j];
            MaxDuration.push(obj.duration+obj.op.delay);
          }
        
          const max = MaxDuration.max();
          maxIndex = MaxDuration.indexOf(max);          
              }
  let i = 0;
    for ( i = 0; i < AryObj.length; i++) {
      var obj = AryObj[i];
      var funcName = obj.api;
      let value = getElements(obj.atoms);
      if (value[0]) {
        let  createGPSA = gsap.timeline();
        if (maxIndex=== i && set===true){
             let newObj = obj.op;
            newObj.onComplete = function(){
                setTimeout(loopClear,100);
             }     
               tempGpsa.push(createGPSA.to([value], obj.duration, newObj)); 
               set = false;
        }else{
       
           tempGpsa.push(createGPSA.to([value], obj.duration, obj.op));
           MaxDuration.push(createGPSA.totalDuration())
        }
      
           collectID.push("#"+obj.atoms)
        }
    }
    // if (loopAnimation && set){
    // Array.prototype.max = function() {
    //   return Math.max.apply(null, this);
    // };
    // const max = MaxDuration.max();
        // const index = MaxDuration.indexOf(max);
    // set = false
      //  let objMax = arrObject[index];
    //   let funcNameMax = objMax.api;
    //   let Maxvalue = getElements(objMax.atoms);
    //   if (Maxvalue[0]) {
    //     let  createGPSA = gsap.timeline();
    //     let newObj = objMax.op;
    //     newObj.onComplete = function(){
    //       setTimeout(loopClear,100);
    //       }     
    //         tempGpsa.push(createGPSA.to([Maxvalue], objMax.duration, newObj));     
    //       }  
    //       }
 
 
  let maxDuration = 0;

  for (let i = 0; i < arrObject.length; i++) {
    let totalDuration = arrObject[i].duration + arrObject[i].op.delay ;
    if (totalDuration > maxDuration) {
      maxDuration = totalDuration ;
    }
  }

  if(loopAnimation > 0){
maxDuration  = maxDuration * (loopAnimation + 1) 
  }else{
  maxDuration += 2
  }
  if(loopAnimation === 0){
  setTimeout(function () {
    for (let i = 0; i < completeObj.length; i++) {
     
      scrollTrap(completeObj[i].id);
      if (completeObj[i].autoScroll) {
        let autoScroll = setInterval(function () {
          ControlThumb(completeObj[i].id);
        }, 90);
        clearTimer[completeObj[i].id] = autoScroll;
      }
    }
   
  }, maxDuration * 1000   ); }
  }
  function loopClear(){
    if (loopAnimation > 0){
   $(collectID.join()).removeAttr("style");
   
    setTimeout(function(){animationRepeat(arrObject);},100);
    
    loopAnimation=loopAnimation-1;
    }
  }

  function stopAndStart(id) {
       clearInterval(clearTimer[id]);

      setTimeout(function () {
        let tinyscrollbar = $("#"+id+"ISIInfo").data("plugin_tinyscrollbar");
 
        tinyscrollbar.update(0);
      }, 1000);
     }
    ${expandClose};
  function ControlThumb(id) {
  var scrollThumbCurrPos = 0;
  var scrollThumbMaxPos = 119; // Top position value of thumb div when collapsed
  var scrollThumbMinPos = 0;
  let scrollTrackHeight = 0;
 
  $("#" + id + "thumb, #" + id + "track, #" + id + "viewport, #" + id + "overview, #" + id + "overview *").bind("click", function () {
    clearInterval(clearTimer[id]);
  });
 
  if (
    $("#" + id + "overview").position().top <=
    parseInt($("#" + id + "viewport").height()) -
    parseInt($("#" + id + "overview").height())
  ) {
    stopAndStart(id);
    $("#" + id + "scrollbar").addClass(id + "activeScroller");
  } else {
    scrollTrackHeight = $("#" + id + "track").height();
    $("#" + id + "scrollbar").addClass(id + "activeScroller");
    scrollThumbCurrPos = parseFloat($("#" + id + "thumb").css("top")); // $("#thumb").position().top;
   
    var maxOverviewTop = $("#" + id + "overview").height() -
                        $("#" + id + "viewport").height(); // Top position value of overview div when fully scrolled down
   
    if (scrollTrackHeight > 100) {
      scrollThumbMaxPos = 208.5; // Top position value of thumb div when expanded
    } else {
      scrollThumbMaxPos = 100; // Top position value of thumb div when collapsed
    }
   
    scrollThumbCurrPos = Math.min(scrollThumbCurrPos - 5, scrollThumbMaxPos);
   
    if (scrollThumbCurrPos < scrollThumbMaxPos) {
      var currContentTop = Math.floor($("#" + id + "overview").position().top);
     
      if (currContentTop <= 0) {
        currContentTop = Math.abs(currContentTop - 1);
      }
     
      currContentTop = Math.min(currContentTop, maxOverviewTop);
     
      let tinyscrollbar = $("#" + id + "ISIInfo").data("plugin_tinyscrollbar");
 
      // Stop scrolling and clear timer once the bottom is reached
      if (currContentTop !== maxOverviewTop) {
        tinyscrollbar.update(currContentTop);
      } else {
        clearInterval(clearTimer[id]);
      }
    } else {
      clearInterval(clearTimer[id]);
    }
  }
}
  function scrollTrap(id) {
    $("#"+id+'ISIInfo').tinyscrollbar();
    var scrollTrackHeight = $("#"+id+'track').height();
    var scrollThumbCurrPos = 0;
    var scrollThumbMaxPos = 119; // top position value of thumb div when collapse
    var scrollThumbMinPos = 0;

    $("#"+id+"arrowBottom").bind("click", function () {
      scrollTrackHeight = $("#"+id+"track").height();

      scrollThumbCurrPos = parseFloat($("#"+id+"thumb").css("top")); //$("#thumb").position().top;
      var maxOverviewTop =
        $("#"+id+"overview").height() - $("#"+id+"viewport").height() + 0; //  top position value of overview div when full scroll down by mousewheel or drag but not clicking bottomArrow
      if (scrollTrackHeight > 97) {
        scrollThumbMaxPos = 533; // top position value of thumb div when expand
      } else {
        scrollThumbMaxPos = 45; // top position value of thumb div when collapse
      }
      scrollThumbCurrPos = scrollThumbCurrPos + 5;
      scrollThumbCurrPos = Math.min(scrollThumbCurrPos, scrollThumbMaxPos);
      //if(scrollThumbCurrPos<=scrollThumbMaxPos){
      var currContentTop = $("#"+id+"overview").position().top;
      if (currContentTop <= 0) {
        currContentTop = currContentTop - 10;
        currContentTop = currContentTop * -1;
      }
      currContentTop = Math.min(currContentTop, maxOverviewTop);
      //console.log(currContentTop);
      if (currContentTop < 4635) {
        var scroll = $("#"+id+"ISIInfo").tinyscrollbar();

        $(scroll).data().plugin_tinyscrollbar.update(currContentTop);
        //  $("#ISIInfo").tinyscrollbar_update(currContentTop);
      }
      //}
    });
    var scrollInterval = null;
    $("#"+id+"arrowBottom" , "#"+id+"arrowTop").bind("mousedown", function (e) {
      if ($(e.target).hasClass("bottom_arrow"))
        scrollInterval = setInterval(function () {
          $(".bottom_arrow").trigger("click");
        }, 100);
      else
        scrollInterval = setInterval(function () {
          $(".top_arrow").trigger("click");
        }, 100);
    });

    $("#"+id+"arrowBottom" , "#"+id+"arrowTop").bind("mouseup mousemove", function (e) {
      clearInterval(scrollInterval);
    });
    $("#"+id+"arrowTop").bind("click", function () {
      scrollTrackHeight = $("#"+id+"track").height();
      scrollThumbCurrPos = $("#"+id+"thumb").position().top;
      scrollThumbCurrPos = scrollThumbCurrPos - 5;
      if (
        scrollThumbCurrPos < scrollThumbMinPos &&
        $("#"+id+"thumb").position().top >= scrollThumbMinPos
      )
        scrollThumbCurrPos = $("#"+id+"thumb").position().top;
      if (scrollThumbCurrPos >= scrollThumbMinPos) {
        var currContentTop = $("#"+id+"overview").position().top;

        if (currContentTop < 0) {
          currContentTop = currContentTop + 10;
          currContentTop = currContentTop * -1;
          currContentTop = Math.max(currContentTop, 0);
        } else currContentTop = 0;
        //console.log(currContentTop);
        var scroll = $("#"+id+'ISIInfo').tinyscrollbar();

        $(scroll).data().plugin_tinyscrollbar.update(currContentTop);
        // $("#ISIInfo").tinyscrollbar_update(currContentTop);
      }
    });
  }
  function pageLoadedHandler() {
    animationRepeat(arrObject);
  }
 
  window.onload = function () {
    if(loaded) {
      if (Enabler.isPageLoaded()) {
        pageLoadedHandler();
      }else {
        Enabler.addEventListener(
          studio.events.StudioEvent.PAGE_LOADED,
          pageLoadedHandler
        );
      }
  }
  else {
    animationRepeat(arrObject);
  }
   
   
  };
 

  for (let i=0; i <completeObj.length; i++) {
  $("#"+completeObj[i].id+'ISIInfo').tinyscrollbar({ trackSize: completeObj[i].trackHeight , thumbSize :completeObj[i].thumbHeight, thumbSizeMin:2, wheelSpeed: 5});
  }
</script>
<script src="https://cdnjs.cloudflare.com/ajax/libs/gsap/3.2.4/gsap.min.js"></script>

<script src="https://cdnjs.cloudflare.com/ajax/libs/gsap/1.10.2/plugins/CSSPlugin.min.js"></script>
  </body>
  </html>
  `;
}
